import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import SpacePath from "components/SpacePath";
import { SpaceAccessLevel } from "types/generated";
import { StackRoleBindingView } from "shared/Stack/Roles/types";

const StackRolesSpaceCell = ({
  item: roleBinding,
  ...cellProps
}: TableSimpleCellProps<StackRoleBindingView>) => {
  const hasAccessToSpace = roleBinding.space.accessLevel !== SpaceAccessLevel.None;

  return (
    <TableSimpleCell {...cellProps}>
      <SpacePath
        spaceId={roleBinding.space.id}
        fallbackName={roleBinding.space.name}
        disabled={!hasAccessToSpace}
        tooltip={!hasAccessToSpace ? "You don't have access to this space" : undefined}
      />
    </TableSimpleCell>
  );
};

export default StackRolesSpaceCell;
